const filterUndefined = (obj) => {
  const result = {};
  for (const [key, value] of Object.entries(obj ?? {})) {
    if (value !== undefined) {
      result[key] = value;
    }
  }

  return result;
};

export default filterUndefined;
